import "bootstrap";
import "jquery";
import "html2canvas";
import "@woocommerce/woocommerce-rest-api";

import html2canvas from "html2canvas";
import axios from "axios";
import * as $ from "jquery";
import * as bootstrap from "bootstrap";

const woocommerceUrl = process.env.WOOCOMMERCE_URL; // Staging

import { Options } from "./options-songtext-poster.js";

const options = new Options();

var PosterPreviewImage, SongModal;
var ShowMobileSettingPanel = true;
var BuilderName = $("body").attr("id");

var SettingsPanel = options.get("settingsPanel", "map");
var PosterSize = options.get("posterSize", "small");
var PosterFrame = options.get("posterFrame", "black");
var AcrylBlock = options.get("acrylBlock", "black");
var SongCover = options.get(
  "SongCover",
  "https://images.genius.com/8c93f8a8cb75088a0357223c8a7b4a6d.1000x1000x1.jpg"
);
var PosterFontStyle = options.get("SongFontStyle", "modern");
var ShowImage = options.get("ShowImage", true, "bool");
var PrintType = options.get("printType", "paper");

let ArtistNameInput = $("#artist-name-input");
let ArtistNameLabel = $(".labels .artist-name");
let SongNameInput = $("#song-name-input");
let SongNameLabel = $(".labels .song-name");
let SubtitleInput = $("#subtitle-input");
let SubtitleLabel = $(".labels .subtitle-2");
let SongtextInput = $("#songtext-input");
let SongTextLabel = $(".js-songtext");
let PosterWrapper = $(".map-wrapper");
let PosterSizeSelect = $(".js-poster-size");
let PosterFrameSelect = $(".js-poster-frame");
let AcrylBlockSelect = $(".js-acryl-block");
let PrintTypeSelect = $(".js-print-type");
let PosterGiftwrapSelect = $(".js-giftwrap");
let GiftCardSelect = $(".js-giftcard");
let GiftCardText = "";
let SearchButton = $(".js-search-song");
let SongsList = $(".js-songs");
let ModalLoader = $(".js-modal-loader");
let CoverImageWrapper = $("#cover-image-wrap");
let CoverImage = $("#image-src image");
let ShowImageToggle = $("#imageToggle");

// Load saved poster
getSavedPoster();
toggleProductionEnv();
calculatePosterPrice();
resizePosterWrapper();
toggleClearIcons();

$(document).ready(function () {
  window.status = "mapbox-ready";
  setTimeout(() => {
    $(".anim-wrapper").removeClass("hidden");
    $(".loading-wrapper").remove();
    scaleFontSize();
  }, "500");
});

// Input listeners
$("input.form-control").on("keyup", function (e) {
  let posterLabel = e.currentTarget.dataset.posterLabel;
  $(".labels ." + posterLabel).html($(this).val());

  if (posterLabel === "artist-name") {
    scaleFontSize();
  }
});

$("input.form-control").on("change", function (e) {
  let posterLabel = e.currentTarget.dataset.posterLabel;
  let inputVal = $(this).val();
  $(".labels ." + posterLabel).html(inputVal);

  if (posterLabel === "artist-name") {
    scaleFontSize();
  }
});

$("textarea.form-control").on("keyup", function (e) {
  let posterLabel = e.currentTarget.dataset.posterLabel;
  if (posterLabel == "songtext") {
    $(".js-songtext").html($(this).val());
    countCharacters($(this).val());
  } else {
    $(".labels ." + posterLabel).html($(this).val());
  }
});

$("textarea.form-control").on("change", function (e) {
  let posterLabel = e.currentTarget.dataset.posterLabel;
  let inputVal = $(this).val();
  if (posterLabel == "songtext") {
    countCharacters(inputVal);
  }
  $(".labels ." + posterLabel).html(inputVal);
});

// Paste listeners
$("input.form-control, textarea.form-control").on("paste", function (e) {
  let posterLabel = e.currentTarget.dataset.posterLabel;

  if (e.originalEvent.clipboardData) {
    var text = e.originalEvent.clipboardData.getData("text/plain");

    if (posterLabel == "songtext") {
      $(".js-songtext").html(text);
      countCharacters($(this).val());
    } else {
      $(".labels ." + posterLabel).html(text);
    }
  }
});

// For counting and limiting the numbers in the songtext
function countCharacters(text) {
  if (!text || text == null || text == "null") {
    $(".js-max-text-bar").css("width", "0%").attr("aria-valuenow", "0");
    return;
  }

  // Get the <path> elements
  var path = $("#spiral-path")[0];
  var textPath = $("#songtext-path")[0];

  // Get the total length of the paths
  var pathLength = path.getTotalLength();
  var textLength = textPath.getComputedTextLength();
  var maxLength = pathLength - 100;

  // Calculate the percentage
  var percentage = (textLength / maxLength) * 100;
  $(".js-max-text-bar")
    .css("width", percentage + "%")
    .attr("aria-valuenow", percentage);

  if (percentage > 99.9) {
    // Trim the text to the specified length along the path
    while (textLength > maxLength) {
      text = text.slice(0, -1);
      $(".js-songtext").html(text);
      textLength = textPath.getComputedTextLength();
    }

    $(".js-max-text-bar").addClass("bg-warning").removeClass("bg-success");
    $(".js-max-chars-warning").removeClass("d-none");
    $("#songtext-input").val(text);
  } else {
    $(".js-max-text-bar").addClass("bg-success").removeClass("bg-warning");
    $(".js-max-chars-warning").addClass("d-none");
  }
}

// Listen to change and show clear icon
$("input.form-control").on("change", function (e) {
  let posterLabel = e.currentTarget.dataset.posterLabel;
  if ($(this).val() === "") {
    $('.js-clear-input[data-field-id="' + posterLabel + '"]').hide();
  } else {
    $('.js-clear-input[data-field-id="' + posterLabel + '"]').show();
  }
});

$(".js-history-back").on("click", function () {
  history.back();
});

// Clear input fields
$(".js-clear-input").on("click", function (e) {
  let field = $(this).data("field-id");
  if (field === "songtext") {
    $(".js-songtext").html("");
    $('textarea.form-control[data-poster-label="' + field + '"]')
      .val("")
      .trigger("focus");
    countCharacters($(this).val());
  } else if (field === "search-song") {
    $('input.form-control[data-poster-label="' + field + '"]')
      .val("")
      .trigger("focus");
    SongsList.empty();
  } else {
    $('input.form-control[data-poster-label="' + field + '"]')
      .val("")
      .trigger("focus");
    $('textarea.form-control[data-poster-label="' + field + '"]')
      .val("")
      .trigger("focus");
    $('.js-clear-input[data-field-id="' + field + '"]').hide();
    $(".labels ." + field).html("");
  }
});

// Check if field has value and show clear icon
function toggleClearIcons() {
  const inputFields = $("input.form-control");
  const textAreas = $("textarea.form-control");

  inputFields.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });

  textAreas.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });
}

// For scaling the font size
function scaleFontSize() {
  const minFontSize = 3.95;
  const maxFontSize = 6.45;
  const lineBreakThreshold = 3.96;
  const text = $(".js-poster-headline");
  const textWrapper = $(".headline-wrapper");
  const parentWidth = textWrapper.width(); // Get the width of the parent container
  let fontSize =
    parseFloat(text.css("font-size")) /
    parseFloat(text.parent().css("font-size")); // Get current font size in em

  // Function to check if text width is smaller than parent width and can grow
  function canGrow() {
    return text[0].scrollWidth <= parentWidth && fontSize < maxFontSize;
  }

  // Function to check if text width exceeds parent width
  function isTextTooWide() {
    return text[0].scrollWidth > parentWidth; // Compare scrollWidth with parent width
  }

  // Loop to shrink the font size if the text is too wide
  while (isTextTooWide() && fontSize > minFontSize) {
    fontSize -= 0.05; // Decrease font size
    text.css("font-size", fontSize + "em"); // Apply new font size
  }

  // Grow the text if it's narrower than the parent and hasn't reached max font size
  while (canGrow()) {
    fontSize += 0.05; // Increase font size
    text.css("font-size", fontSize + "em"); // Apply new font size
  }

  // Check if the font size is at the minimum threshold
  if (fontSize <= lineBreakThreshold) {
    text.css("white-space", "pre-wrap"); // Allow wrapping of text
    // text.html(text.text().replace(/ /g, ' ')); // Replace spaces with spaces + line breaks if needed
  } else {
    text.css("white-space", "nowrap"); // Allow wrapping of text
  }
}

// Changing poster
function setPosterSize(posterSize) {
  if (PrintType === "paper") {
    PosterWrapper.removeClass().addClass(
      "map-wrapper size-" + posterSize + " " + PrintType
    );
  } else {
    PosterWrapper.removeClass().addClass("map-wrapper size-small " + PrintType);
  }
}

// Change poster font
$(".js-font-option").on("click", function () {
  PosterFontStyle = $(this).attr("data-font");
  setPosterFontSelection(PosterFontStyle);
  setPosterFontStyle(PosterFontStyle);
  dismissSettingsPanel();

  setTimeout(() => {
    scaleFontSize();
  }, 50);
});

function setPosterFontStyle(font) {
  $(".poster-canvas .labels").removeClass("modern classic mono");
  $(".poster-canvas .labels").addClass(font);
}

function setPosterFontSelection(font) {
  var selectedFont = $('.js-font-option[data-font="' + font + '"]');
  $(".js-font-option").removeClass("active");
  selectedFont.addClass("active");
}

// Change poster size
$(".js-size-option").on("click", function () {
  PosterSize = $(this).attr("data-size");
  setPosterSize(PosterSize);
  if (PrintType === "paper") {
    setFramePrice(PosterSize);
  }
  setSizeSelection(PosterSize);
  calculatePosterPrice();
});

function setSizeSelection(posterSize) {
  let selectedSize;
  if (PrintType === "acryl") {
    selectedSize = $(
      '.js-show-for-acryl .js-size-option[data-size="' + posterSize + '"]'
    );
  } else {
    selectedSize = $(
      '.js-hide-for-acryl .js-size-option[data-size="' + posterSize + '"]'
    );
  }
  $(".js-size-option").removeClass("active");
  selectedSize.addClass("active");
}

// Change print type
$(".js-print-option").on("click", function () {
  let SelectedPrintType = $(this).attr("data-print");
  if (PrintType !== SelectedPrintType) {
    PrintType = SelectedPrintType;
    setPrintType(PrintType);
  }
});

function setPrintType(PrintType) {
  var selectedPrint = $('.js-print-option[data-print="' + PrintType + '"]');
  $(".js-print-option").removeClass("active");
  selectedPrint.addClass("active");
  if (PrintType === "acryl") {
    if (PosterSize === "large" || PosterSize === "medium") {
      PosterSize = "small";
    }
    PosterFrame = "no-frame";
    setPosterSize(PosterSize);
    setSizeSelection(PosterSize);
    setPosterFrame(PosterFrame);
    setFrameSelection(PosterFrame);
    $(".js-hide-for-acryl").hide();
    $(".js-show-for-acryl").show();
  } else {
    if (PosterSize === "xs") {
      PosterSize = "small";
    }
    AcrylBlock = "no-block";
    setAcrylBlock(AcrylBlock);
    setBlockSelection(AcrylBlock);
    setPosterSize(PosterSize);
    setSizeSelection(PosterSize);
    $(".js-hide-for-acryl").show();
    $(".js-show-for-acryl").hide();
  }
  activateGiftwrap();
  calculatePosterPrice();
}

// Change acryl block
$(".js-block-option").on("click", function () {
  AcrylBlock = $(this).attr("data-block");
  setBlockSelection(AcrylBlock);
  setAcrylBlock(AcrylBlock);
  calculatePosterPrice();
});

function setBlockSelection(AcrylBlock) {
  var selectedBlock = $('.js-block-option[data-block="' + AcrylBlock + '"]');
  $(".js-block-option").removeClass("active");
  selectedBlock.addClass("active");
}

function setAcrylBlock(AcrylBlock) {
  if (AcrylBlock == "black") {
    $(".acryl-block").removeClass("d-none oak").addClass("black");
  } else if (AcrylBlock == "oak") {
    $(".acryl-block").removeClass("d-none black").addClass("oak");
  } else {
    $(".acryl-block").removeClass("oak black").addClass("d-none");
  }
}

// Change poster frame
$(".js-frame-option").on("click", function () {
  PosterFrame = $(this).attr("data-frame");
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  activateGiftwrap();
  calculatePosterPrice();
});

function setPosterFrame(PosterFrame) {
  if (PosterFrame == "black") {
    $(".poster-frame").removeClass("d-none oak-frame").addClass("black-frame");
  } else if (PosterFrame == "oak") {
    $(".poster-frame").removeClass("d-none black-frame").addClass("oak-frame");
  } else {
    $(".poster-frame").removeClass("oak-frame black-frame").addClass("d-none");
  }
}

function setFrameSelection(frame) {
  var selectedFrame = $('.js-frame-option[data-frame="' + frame + '"]');
  $(".js-frame-option").removeClass("active");
  selectedFrame.addClass("active");
}

// Toggle giftwrap
$(".js-giftwrap").on("change", function () {
  calculatePosterPrice();
});

function activateGiftwrap() {
  if (PosterFrame === "no-frame" && PrintType !== "acryl") {
    PosterGiftwrapSelect.val("false");
    $(".js-giftwrap option[value=true]")
      .attr("disabled", "disabled")
      .siblings()
      .removeAttr("disabled");
  } else {
    $(".js-giftwrap option[value=true]").removeAttr("disabled");
  }
}

// Change giftcard text
$(".js-giftcard").on("change", function () {
  if ($(this).val() === "true") {
    $(".js-giftcard-text").show();
    GiftCardText = $(".js-giftcard-text").val();
  } else {
    $(".js-giftcard-text").hide();
    GiftCardText = "";
  }
  calculatePosterPrice();
});

$(".js-giftcard-text").on("change", function () {
  GiftCardText = $(this).val();
});

// Calculate poster price
function calculatePosterPrice() {
  getProductVariation();
  let PosterPrice = parseFloat(
    PosterSizeSelect.find(".active").attr("data-price")
  );
  let FramePrice = parseFloat(
    PosterFrameSelect.find(".active").attr("data-price")
  );
  let BlockPrice = parseFloat(
    AcrylBlockSelect.find(".active").attr("data-price")
  );
  let GiftwrapPrice = parseFloat(
    PosterGiftwrapSelect.find(":selected").attr("data-price")
  );
  let GiftCardPrice = parseFloat(
    GiftCardSelect.find(":selected").attr("data-price")
  );
  let SubtotalPrice =
    PosterPrice + FramePrice + BlockPrice + GiftwrapPrice + GiftCardPrice;
  $(".subtotal").html(
    "€" + SubtotalPrice.toFixed(2).toString().replace(".", ",")
  );
}

function setFramePrice(PosterSize) {
  var FramePrices = {
    small: "15",
    medium: "20",
    large: "35",
  };
  $(".js-frame-price").html("€" + FramePrices[PosterSize].toString() + ",-");
  $(".js-frame-option.framed").attr("data-price", FramePrices[PosterSize]);
}

// Create poster preview image
function createPosterPreview() {
  $(".poster-frame").css("z-index", "0");
  html2canvas(document.querySelector(".poster-wrapper"), { scale: 0.7 }).then(
    (canvas) => {
      resizePosterWrapper();
      PosterPreviewImage = canvas.toDataURL("image/png", 1.0);
      $(".js-poster-preview").attr("src", PosterPreviewImage);
    }
  );
  $(".poster-frame").css("z-index", "10");
}

// For getting songtext
$(".js-search-song").on("click", function (e) {
  handleSearch();
});

$(".js-search-field").on("keydown", function (e) {
  if (e.key === "Enter") {
    $(this).trigger("blur");
    handleSearch();
  }
});

function handleSearch() {
  SearchButton.prop("disabled", true);
  let inputVal = $(".js-search-field").val();
  getSongtext(inputVal);
  SongsList.empty();
}

function getSongtext(query) {
  async function searchSong(query) {
    try {
      const response = await axios.get(process.env.GENIUS_URL, {
        params: {
          q: query,
          access_token: process.env.GENIUS_API_KEY,
        },
        headers: {
          withCredentials: false,
        },
      });
      listSongs(response.data.response.hits);
      SearchButton.prop("disabled", false);
    } catch (error) {
      console.error("Error fetching song data:", error);
      SearchButton.prop("disabled", false);
    }
  }

  searchSong(query);
}

function listSongs(hits) {
  if (hits && hits.length > 0) {
    hits.forEach((hit) => {
      var Artist = hit.result.artist_names;
      var SongTitle = hit.result.title;
      var SongID = hit.result.url;
      var songImg = hit.result.header_image_thumbnail_url;
      var coverImg = hit.result.header_image_url;
      SongsList.append(
        `<a href="#" class="list-group-item list-group-item-action d-flex" data-artist="${Artist}" data-song-title="${SongTitle}" data-cover-img="${coverImg}" data-song-url="${SongID}"><div class="song-img-wrap" style="background-image:url(${songImg});"></div><div>${Artist}<br/><div class="song-title">${SongTitle}</div></div></a>`
      );
    });
  } else {
    SongsList.append(
      `<p class="text-center">Leider konnten wir nichts finden :(</p>`
    );
  }
  initSongsList();
}

function initSongsList() {
  $(".list-group-item").on("click", function () {
    let songURL = $(this).data("song-url");
    let songTitle = $(this).data("song-title");
    let artist = $(this).data("artist");
    SongCover = $(this).data("cover-img");
    loadSong(songURL, songTitle, artist);
    ModalLoader.removeClass("hidden");
  });
}

function loadSong(songURL, songTitle, artist) {
  async function fetchLyrics(songUrl) {
    try {
      // Fetch page content using ScrapingBee
      const response = await axios.get("https://app.scrapingbee.com/api/v1", {
        params: {
          api_key: process.env.SCRAPING_BEE_API_KEY,
          url: songUrl,
        },
      });

      const html = response.data;

      // Parse the HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find all lyrics containers
      const lyricsContainers = doc.querySelectorAll(
        "div[data-lyrics-container]"
      );
      if (!lyricsContainers.length)
        throw new Error("Lyrics not found on page.");

      let lyrics = "";

      lyricsContainers.forEach((container) => {
        // Remove all elements with data-exclude-from-selection="true"
        const excludedElements = container.querySelectorAll(
          '[data-exclude-from-selection="true"]'
        );
        excludedElements.forEach((el) => el.remove());

        // Then extract lyrics as normal
        lyrics += extractTextWithBreaks(container) + "\n";
      });

      // Clean up lyrics text: Remove metadata and extra spaces
      const cleanedLyrics = lyrics
        .replace(/\[.*?\]/g, "") // Remove [Verse 1], [Chorus], etc.
        .replace(/\s+/g, " ") // Normalize whitespace
        .trim();

      const trimmedLyrics = trimToCompleteWord(cleanedLyrics, 720);

      // Update UI
      ArtistNameLabel.html(artist);
      ArtistNameInput.val(artist);
      SongNameLabel.html(songTitle);
      SongNameInput.val(songTitle);
      SongTextLabel.html(trimmedLyrics);
      SongtextInput.val(trimmedLyrics);
      countCharacters(trimmedLyrics);

      getCoverImage(SongCover);

      ModalLoader.addClass("hidden");
      SongModal.hide();
      setTimeout(() => {
        dismissSettingsPanel();
        scaleFontSize();
      }, 500);
    } catch (error) {
      console.error("Error fetching lyrics:", error);
      ModalLoader.addClass("hidden");
      $(".js-alert-songtext").removeClass("d-none");
    }
  }

  fetchLyrics(songURL);
}

function extractTextWithBreaks(element) {
  let textContent = "";
  element.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.trim();
      if (text) textContent += text + " ";
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName === "BR") {
        textContent += "\n"; // Treat <br> as a line break
      }
      textContent += extractTextWithBreaks(node); // Process child nodes recursively
    }
  });
  return textContent.trim();
}

function trimToCompleteWord(text, maxLength = 720) {
  // Trim the text to the maxLength if it’s longer
  if (text.length > maxLength) {
    // Cut the text at maxLength
    let trimmedText = text.slice(0, maxLength);

    // Find the last space within the trimmed text to ensure a complete word
    const lastSpaceIndex = trimmedText.lastIndexOf(" ");

    // If there’s a space, cut off from that point to avoid a partial word
    if (lastSpaceIndex !== -1) {
      trimmedText = trimmedText.slice(0, lastSpaceIndex);
    }

    return trimmedText + "...";
  }

  // If text is shorter than maxLength, return it as-is
  return text;
}

function getCoverImage(imageURL) {
  (async () => {
    const imageUrl = imageURL;
    try {
      const base64Image = await convertImageToBase64(imageUrl);
      CoverImage.attr("xlink:href", base64Image);
    } catch (err) {
      console.log("Failed to convert image:", err);
    }
  })();
}

const convertImageToBase64 = async (imageUrl) => {
  try {
    // Fetch the image as a binary buffer
    const response = await axios.get(imageUrl, {
      responseType: "arraybuffer", // Important for binary data
    });

    // Get the image type (e.g., png, jpg)
    const contentType = response.headers["content-type"]; // Example: 'image/jpeg'

    // Encode the binary data to Base64
    const base64Image = Buffer.from(response.data).toString("base64");

    // Return the Base64 string with data URI prefix
    return `data:${contentType};base64,${base64Image}`;
  } catch (error) {
    console.error("Error converting image to Base64:", error);
    throw error;
  }
};

// Toggle hide end points
ShowImageToggle.on("change", function () {
  ShowImage = $(this).is(":checked");
  toggleImageVisibility(ShowImage);
});

function toggleImageVisibility(ShowImage) {
  if (ShowImage) {
    CoverImageWrapper.css("opacity", "1");
  } else {
    CoverImageWrapper.css("opacity", "0");
  }
}

// For hiding some unnecessary fields on staging
function toggleProductionEnv() {
  if (process.env.USE_CART === "false") {
    $(".production-options").hide();
    $(".concept-copy").hide();
  }
  if (process.env.OAK_FRAMES === "false") {
    $('[data-frame="oak"]').remove();
  }
  if (process.env.ACRYL_PRODUCTS === "false") {
    if (PrintType === "acryl") {
      PrintType = "paper";
      PosterWrapper.removeClass("acryl");
    }
    $(".js-show-for-acryl").remove();
    $(".js-hide-for-acryl").show();
    $(".js-material-toggle").remove();
  }
}

// For saving design to local storage
function saveDesign() {
  localStorage.setItem("posterSize", PosterSize);
  localStorage.setItem("posterFrame", PosterFrame);
  localStorage.setItem("ArtistName", ArtistNameLabel.html());
  localStorage.setItem("SongName", SongNameLabel.html());
  localStorage.setItem("SongSubtitle", SubtitleLabel.html());
  localStorage.setItem("SongText", SongTextLabel.html());
  localStorage.setItem("SongCover", SongCover);
  localStorage.setItem("SongFontStyle", PosterFontStyle);
  localStorage.setItem("ShowImage", ShowImage);
  localStorage.setItem("printType", PrintType);
  localStorage.setItem("acrylBlock", AcrylBlock);
}

// For getting design from local storage or parameters
function getSavedPoster() {
  // Prepare text labels
  if (BuilderName !== "PrintApp") {
    SongModal = new bootstrap.Modal(document.getElementById("song-modal"));

    // Hide error on close modal
    document
      .getElementById("song-modal")
      .addEventListener("hide.bs.modal", function (event) {
        $(".js-alert-songtext").addClass("d-none");
      });

    if (options.get("ArtistName") !== null) {
      var ArtistName = options.get("ArtistName");
    } else {
      var ArtistName = "Goo Goo Dolls";
    }

    if (options.get("SongName") !== null) {
      var SongName = options.get("SongName");
    } else {
      var SongName = "Iris";
    }

    if (options.get("SongSubtitle") !== null) {
      var Subtitle = options.get("SongSubtitle");
    } else {
      var Subtitle = "Our song";
    }

    if (options.get("SongText") !== null) {
      var SongText = options.get("SongText");
    } else {
      var SongText =
        "You turn my guitar on And I'd give up forever to touch you 'Cause I know that you feel me somehow You're the closest to heaven that I'll ever be And I don't want to go home right now 'Cause all I can taste is this moment And all I can breathe is your life So and sooner or later, it's over I just don't wanna miss you tonight And I don't want the world to see me 'Cause I don't think that they'd understand When everything's made to be broken I just want you to know who I am And you can't fight the tears that ain't coming Or the moment of truth in your lies So when everything feels like the movies Yeah, you bleed...";
    }
  } else {
    var ArtistName = options.get("ArtistName");
    var SongName = options.get("SongName");
    var Subtitle = options.get("SongSubtitle");
    var SongText = options.get("SongText");
  }

  // Set text labels
  ArtistNameLabel.html(ArtistName);
  ArtistNameInput.val(ArtistName);
  SongNameLabel.html(SongName);
  SongNameInput.val(SongName);
  SubtitleLabel.html(Subtitle);
  SubtitleInput.val(Subtitle);
  SongTextLabel.html(SongText);
  SongtextInput.val(SongText);
  CoverImage.attr("xlink:href", SongCover);

  if (BuilderName !== "PrintApp") {
    countCharacters(SongText);
    setBlockSelection(AcrylBlock);
    setAcrylBlock(AcrylBlock);
  }

  if (PrintType !== "acryl") {
    if (PosterSize === "xs") {
      PosterSize = "small";
    }
    setFramePrice(PosterSize);
  }
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);

  PosterFrame = options.get("posterFrame");
  PosterFrame = PosterFrame === "framed" ? "black" : PosterFrame;
  PosterFrameSelect.val(PosterFrame);
  setPosterFrame(PosterFrame);
  PrintTypeSelect.val(PrintType);
  setPrintType(PrintType);
  setFrameSelection(PosterFrame);
  activateGiftwrap();

  setPosterFontStyle(PosterFontStyle);
  setPosterFontSelection(PosterFontStyle);

  toggleImageVisibility(ShowImage);
  if (!ShowImage) {
    ShowImageToggle.prop("checked", false);
  }
}

// Resize canvas
$(window).resize(function () {
  resizePosterWrapper();
});

function resizePosterWrapper() {
  var scaleFix;
  if ($(window).width() <= 600) {
    scaleFix = 2000;
  } else {
    scaleFix = 1600;
  }
  var scale = $(window).height() / scaleFix;
  if (scale <= 1) {
    $(".poster-wrapper").css("transform", "scale(" + scale + ")");
  }
}

// Toggle settings panels
$(".js-settings-toggle").on("click", function () {
  var target = $(this).attr("data-target");

  if (target == "text" && SettingsPanel !== "text") {
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.text").removeClass("d-none");
    SettingsPanel = "text";
  } else if (target == "size" && SettingsPanel !== "size") {
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.size").removeClass("d-none");
    SettingsPanel = "size";
  } else if (target == "shop" && SettingsPanel !== "shop") {
    setPosterSummary();
    $(".settings-panel").addClass("d-none");
    $(".settings-panel.shop").removeClass("d-none");
    $(".nav-pills .nav-link").removeClass("active");
    $("#pills-shop-tab").addClass("active");
    SettingsPanel = "shop";
  }

  if (ShowMobileSettingPanel == false) {
    $(".side-nav").addClass("shown");
    ShowMobileSettingPanel = true;
  }
  $(".options-container").scrollTop(0);
  saveDesign();
});

$(".js-close-settings").on("click", function () {
  dismissSettingsPanel();
});

function dismissSettingsPanel() {
  $(".side-nav").removeClass("shown");
  ShowMobileSettingPanel = false;
}

// Prepping shopping cart
function setPosterSummary() {
  createPosterPreview();
  if (PrintType === "acryl") {
    $(".js-bag-poster-size").html(
      $(".js-show-for-acryl .js-poster-size .active").text()
    );
    $(".js-bag-poster-frame").html($(".js-acryl-block .active").text());
  } else {
    $(".js-bag-poster-size").html(
      $(".js-hide-for-acryl .js-poster-size .active").text()
    );
    $(".js-bag-poster-frame").html($(".js-poster-frame .active").text());
  }
  $(".js-bag-giftwrap").html($(".js-giftwrap option:selected").text());
  if (PosterGiftwrapSelect.val() === "true") {
    $(".js-bag-giftwrap").html("Mit Geschenkpapier + €3,95");
  }
  if (GiftCardSelect.val() === "true") {
    $(".js-bag-giftcard").html("Mit persönlicher Nachricht + €1,95");
  }
}

function getProductVariation() {
  if (PrintType === "acryl") {
    var productVariations = {
      id: 39555,
      "xs-black": 39561,
      "small-black": 39560,
      "xs-oak": 39559,
      "small-oak": 39558,
      "xs-no-block": 39557,
      "small-no-block": 39556,
    };
    var ProductVariationKey = PosterSize + "-" + AcrylBlock;
  } else {
    var productVariations = {
      id: 27942,
      "small-no-frame": 27947,
      "medium-no-frame": 27949,
      "large-no-frame": 27951,
      "small-black": 27948,
      "medium-black": 27950,
      "large-black": 27946,
      "small-oak": 27943,
      "medium-oak": 27944,
      "large-oak": 27945,
    };
    var ProductVariationKey = PosterSize + "-" + PosterFrame;
  }
  var PosterVariation = {
    id: productVariations.id,
    variation_id: productVariations[ProductVariationKey],
  };
  return PosterVariation;
}

// Adding poster to cart
$(".js-save-poster").on("click", function () {
  let ProductID = getProductVariation();

  $(this).html("Poster opslaan...").prop("disabled", true);

  let payload = {
    "add-builder-item-to-cart": true,
    thumbnail: PosterPreviewImage,
    product_id: ProductID.id,
    variation_id: ProductID.variation_id,
    previous_cart_item_id: options.get("previousCartItemId"),
    poster: {
      size: PosterSize,
      frame: PosterFrame,
      giftwrap: PosterGiftwrapSelect.val(),
      giftcardText: GiftCardText,
      ArtistName: localStorage.getItem("ArtistName"),
      SongName: localStorage.getItem("SongName"),
      SongSubtitle: localStorage.getItem("SongSubtitle"),
      SongText: localStorage.getItem("SongText"),
      SongCover: localStorage.getItem("SongCover"),
      SongFontStyle: localStorage.getItem("SongFontStyle"),
      ShowImage: localStorage.getItem("ShowImage"),
      main: localStorage.getItem("ArtistName"),
      subtitle: localStorage.getItem("SongName"),
    },
    pdf: {
      type: "songtext",
      print: PrintType,
    },
  };

  // console.log("Payload: ", payload);

  let action =
    process.env.USE_CART === "true" ? "add-to-cart" : "add-poster-order";

  $.ajax({
    url: woocommerceUrl + "/wp-json/wallable/v1/" + action,
    type: "POST",
    // crossDomain: true,
    contentType: "application/json",
    data: JSON.stringify(payload),
    error: (error) => {
      console.error(error);
      setTimeout(() => {
        if (!$(".js-notifications").find(".js-error").length) {
          $(".js-notifications").append(
            '<div class="js-error alert alert-danger text-center p-2">Er ging iets mis, probeer het later opnieuw</div>'
          );
        }
        $(this).html("Toevoegen aan winkelwagen").prop("disabled", false);
      }, 500);
    },
    success: () => {
      if (process.env.USE_CART === "true") {
        $(this).html("Toevoegen aan winkelwagen").prop("disabled", false);
        window.location = woocommerceUrl + "/cart";
      } else {
        if (!$(".js-notifications").find(".js-error").length) {
          $(".js-notifications").append(
            '<div class="js-success alert alert-success text-center p-2">&#x2713; Poster toegevoegd</div>'
          );
        }

        $(this).html("Toevoegen aan winkelwagen").prop("disabled", false);
      }
    },
  });
});
